import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const TermsOfUse = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-[#f6ffe6] to-[#c4ffa0]/30">
      <Header />
      <main className="flex-grow">
        <section className="max-w-3xl mx-auto px-4 py-20">
          <h1 className="text-4xl font-bold text-[#2d4a1e] mb-6">Terms of Use</h1>
          <div className="bg-white border border-green-100 rounded-2xl p-8 shadow-sm">
            <p className="text-gray-700 mb-4">
              Welcome to kinOS! These Terms of Use govern your use of our website and services. By accessing or using kinOS, you agree to be bound by these terms.
            </p>
            <h2 className="text-2xl font-semibold text-[#2d4a1e] mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By using our site, you agree to comply with and be legally bound by these Terms of Use and our Privacy Policy.
            </p>
            <h2 className="text-2xl font-semibold text-[#2d4a1e] mt-8 mb-4">2. Use of Service</h2>
            <p className="text-gray-700 mb-4">
              You agree to use kinOS only for lawful purposes and in accordance with these terms. You are responsible for your use of the site and any content you provide.
            </p>
            <h2 className="text-2xl font-semibold text-[#2d4a1e] mt-8 mb-4">3. Intellectual Property</h2>
            <p className="text-gray-700 mb-4">
              All content, trademarks, and data on this site, including but not limited to software, databases, text, graphics, icons, and hyperlinks are the property of kinOS or its licensors.
            </p>
            <h2 className="text-2xl font-semibold text-[#2d4a1e] mt-8 mb-4">4. Changes to Terms</h2>
            <p className="text-gray-700 mb-4">
              We reserve the right to update or change these Terms of Use at any time. Your continued use of the site after any changes constitutes acceptance of those changes.
            </p>
            <h2 className="text-2xl font-semibold text-[#2d4a1e] mt-8 mb-4">5. Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have any questions about these Terms, please contact us at <a href="mailto:support@usekinos.com" className="text-green-600 underline">support@usekinos.com</a>.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfUse; 